function createTab(heading) {
  return $(
    '<accordion-disclosure class="accordion">' +
      '<details class="accordion__disclosure group" aria-expanded="false">' +
        '<summary><span class="accordion__toggle h6"><span class="text-with-icon gap-4">' +
          heading +
          '</span><span class="animated-plus group-expanded:rotate" aria-hidden="true" style=""></span></span>' +
        '</summary>' +
        '<div class="accordion__content prose"><div class="Rte"></div></div>' +
      '</details>' +
    '</accordion-disclosure>'
  );
}

function productDescTabs() {
  let $desc = $("[data-block-type='description']");
  let $tabs = $(".Product__Tabs");
  let tabs = [];
  // create tabs from content
  $desc.find("h2, h3, h4, h5, h6").each(function () {
    let $heading = $(this);
    let $list = $heading.next();
    if (!$list || !$list.is("ul, p")) {
      return;
    }
    let $tab = createTab($heading.text());
    $tab.find(".Rte").append($list);
    $heading.remove();
    tabs.push($tab);
  });
  $.each(tabs.reverse(), function (i, $tab) {
    $tabs.prepend($tab);
  });
}

// events
(function ($) {
  if (window.theme.pageType === "product") {
    productDescTabs();
  }
})(jQuery);